var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "overlay" }, [
      _vm.$route.name === "Home"
        ? _c("div", [
            _c("div", { staticClass: "overlay-body" }, [
              _c("div", [
                _c("p", { staticClass: "frail-text" }, [
                  _vm._v(_vm._s(_vm.todayDate) + "月度の"),
                  _c("br"),
                  _vm._v("基本データ"),
                  _c("br"),
                  _vm._v("健康度チェック"),
                  _c("br"),
                  _vm._v("をしましょう")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tap-contents" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "back-img btn-img",
                      on: { click: _vm.homeback }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/meal_history/アセット 20@2x.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("router-link", { attrs: { to: "/frailtyRiskCheck" } }, [
                    _c("div", { staticClass: "record-img btn-img" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/meal_history/アセット 21@2x.png")
                        }
                      })
                    ])
                  ])
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a1e8c4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1e8c4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FrailCheckAlert.vue
// module id = null
// module chunks = 